module.exports = __webpack_public_path__ + "static/img/guide-topico4.b353db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-topico4.png
// module id = 61xW
// module chunks = 1